import {authStore} from "../store";
import {apiStatus} from "./index";
import {ShipmentProcessTypeDto, ShipmentTypeDto, ShippingDestinationTypeDto} from "./fms";
import {
    ShipmentTypeDto as CmsShipmentTypeDto,
    ShippingDestinationTypeDto as CmsShippingDestinationTypeDto,
    ShipmentProcessTypeDto as CmsShipmentProcessTypeDto
} from "./cms";

export async function catchApi<T>(call: () => T) {
    try {
        return await call()
    } catch (e) {
        if (e instanceof Response) {
            const response = e as Response
            const statusText = 'Error'
            if (response.status === 403) {
                apiStatus.addError({
                    statusText: `${response.status} - Zugriff verweigert`,
                    data: `Zugriff auf ${response.url} verweigert`
                })
                return
            }
            if (response.status === 404) {
                apiStatus.addError({
                    statusText: `${response.status} - Nicht gefunden`,
                    data: `Die Adresse ${response.url} wurde nicht gefunden`
                })
                return
            }
            try {
                let data = await response.text()
                try {
                    data = JSON.parse(data)
                } catch (e2) {}
                apiStatus.addError({
                    statusText,
                    data
                })
            } catch (e2) {
                apiStatus.addError({
                    statusText,
                    data: e2
                })
            } finally {
                if (response.status === 401) {
                    authStore.clear()
                }
            }
        } else if (e instanceof TypeError) {
            const te = e as TypeError
            apiStatus.addError({
                statusText: te.name,
                data: te.message
            })
        } else {
            console.log('unknown error', e)
            throw e
        }
    }
}

export interface ShippingClientId {
    value: string | undefined
    defaultValue: string | undefined
}

export type ShipmentTypeWithoutPost = Exclude<ShipmentTypeDto | CmsShipmentTypeDto, ShipmentTypeDto.POST>
export type ShipmentProcessType = ShipmentProcessTypeDto | CmsShipmentProcessTypeDto
export type ShippingConfigDestinationConstruct = Record<ShipmentTypeWithoutPost, ShippingClientId>
export type ShippingConfigProcessConstruct = Record<ShippingDestinationTypeDto | CmsShippingDestinationTypeDto, ShippingConfigDestinationConstruct>

export type ShippingConfigConstruct = Record<ShipmentProcessTypeDto, ShippingConfigProcessConstruct>

export function buildShippingConfigConstruct(
    original: ShippingConfigConstruct,
    process: ShipmentProcessTypeDto | CmsShipmentProcessTypeDto,
    destination: ShippingDestinationTypeDto | CmsShippingDestinationTypeDto,
    type: ShipmentTypeDto | CmsShipmentTypeDto,
    value: ShippingClientId
): ShippingConfigConstruct {
    return {
        ...original,
        [process]: {
            ...original[process],
            [destination]: {
                ...original[process][destination],
                [type]: value
            }
        }

    }
}

